import { Link } from 'react-router-dom';

const stats = [
  { value: '6', label: '收录影视作品', icon: 'ri-film-line' },
  { value: '16', label: '角色详解资料', icon: 'ri-user-3-line' },
  { value: '4', label: '深度影视专题', icon: 'ri-book-2-line' },
  { value: '100%', label: '内容可检索', icon: 'ri-search-eye-line' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 font-label text-xs text-primary-700">
            <i className="ri-information-line"></i> 关于本站
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            一处专门整理影视剧情与角色的资料站
          </h2>
          <p className="mt-4 text-sm leading-8 text-foreground-700">
            玉女心经2 影视内容站，专注影视作品的剧情解析、角色信息与背景资料整理。我们把零散的信息梳理成清晰可查的资料，让喜欢钻研剧情和人物的影迷，能在一个整洁的地方把它们一次看全。
          </p>
          <p className="mt-3 text-sm leading-8 text-foreground-700">
            网站不含登录、支付与在线播放，只做一件事——把作品和人物讲清楚。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-arrow-right-circle-line text-lg"></i> 了解更多
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <p className="mt-4 font-heading text-2xl font-black text-foreground-950">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}